import React from "react"
// import { Link as RouterLink } from "react-router-dom"
import { makeStyles } from "@material-ui/core/styles"
// import ShareIcon from "@material-ui/icons/Share"
// import Button from "./Button"

const useStyles = makeStyles((theme) => ({
  root: {
    marginBottom: theme.spacing(1),
    textAlign: "right",
  },
}))

const DocumentsHeader = () => {
  const classes = useStyles()

  return (
    <div className={classes.root}>
      {/* <Button
        color="secondary"
        startIcon={<ShareIcon />}
        component={RouterLink}
        to="/0/documents/send"
        variant="text"
      >
        Share Documents
      </Button> */}
    </div>
  )
}

export default DocumentsHeader
